/* eslint-disable react/prop-types */
import { useRef, useState } from "react";
import { MapPin, Play, Star } from "lucide-react";

const PLAY = "Google Play Review";
const VIDEO =
  "https://jaaga-public-1722574714.s3.ap-south-1.amazonaws.com/WhatsApp+Video+2025-05-08+at+13.50.21_fb96abe6.mp4";
const TITLE_REVIEW =
  "I took Jaaga’s Title Verification Report service for my property, and it exceeded my expectations. They checked the title thoroughly and also provided my Sale Deed and Mutation records without any hassle. Their legal team was super helpful and made the entire process stress-free. A must-try for anyone looking for trusted and cost-effective property verification services!";

// Same reviews the old testimonials + Play-review rows used, in the MVP's order.
const REVIEWS = [
  { name: "Anjan Kumar", from: PLAY, date: "20 March 2026", helpful: 15, color: "#153568",
    text: "Excellent service, quick response by the team and immediate action. I really like this app and suggest it to retrieve documents. It is safe and genuine." },
  { name: "Raghavendra", from: "Hyderabad, Telangana", video: VIDEO, color: "#0f766e" },
  { name: "Kallam Ashwini", from: PLAY, date: "7 May 2026", helpful: 5, color: "#6d4aff",
    text: "Very professional and trustworthy service for property related documentation. Quick response, smooth processing, and good customer support. Highly recommended." },
  { name: "Kondanna", from: "Hyderabad, Telangana", color: "#b45309", text: TITLE_REVIEW },
  { name: "Manikanta Reddy Chirra", from: PLAY, date: "2 April 2026", color: "#15803d",
    text: "Their customer support is 100 times better than other platforms. My electricity bill name update completed in 15 days." },
  { name: "Chandra Sekhar J", from: "Hyderabad, Telangana", color: "#2f6db5",
    text: "I used Jaaga’s PTIN Creation service for my new property, and the process was seamless. They handled everything with GHMC and ensured my property was properly registered for tax. I didn’t have to worry about the paperwork or follow-ups. They took care of it all. Highly recommend it for anyone needing a new PTIN or tax record correction!" },
  { name: "Akhila Priya", from: "Hyderabad, Telangana", color: "#c2410c",
    text: "JaaGa's assistance was a lifesaver when we forgot our property details. Within the same day, they efficiently retrieved all the required documents, ensuring a hassle-free experience." },
  { name: "Srinivas G", from: "Vizag, Andhra Pradesh", date: "9 July 2025", color: "#0e7490",
    text: "The Property Audit Report from JaaGa was extremely helpful for me. It combined all my essential property documents into one organized and easily accessible binder, simplifying the entire management process." },
  { name: "Sai Sekhar Reddy M", from: "Guntur, Andhra Pradesh", color: "#9333ea",
    text: "I was really impressed with how easy Jaaga made it to get important documents like my EC, Sale Deed, and Passbook. The whole process was smooth and hassle-free, and I didn’t have to run around or deal with delays. Their team was super reliable, and the best part was that it was all done at a very reasonable cost. It saved me so much time and stress!" },
];

const Stars = () => (
  <span className="mh-stars" role="img" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} size={15} fill="currentColor" strokeWidth={0} aria-hidden="true" />
    ))}
  </span>
);

const VideoClip = ({ src, name, hidden }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  return (
    <div className="mh-tvid">
      <video ref={ref} src={`${src}#t=0.5`} preload="metadata" playsInline controls={playing} onEnded={() => setPlaying(false)} />
      {!playing && (
        <button
          type="button"
          className="mh-play"
          aria-label={`Play video review by ${name}`}
          tabIndex={hidden ? -1 : 0}
          onClick={() => {
            setPlaying(true);
            ref.current?.play();
          }}
        >
          <Play size={22} fill="currentColor" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

const ReviewCard = ({ r, hidden }) => (
  <article className="mh-tcard" aria-hidden={hidden}>
    {r.video && <VideoClip src={r.video} name={r.name} hidden={hidden} />}
    <div className="mh-tbody">
      <div className="mh-trow">
        <Stars />
        {r.date && <span>{r.date}</span>}
      </div>
      {r.text && <p className="mh-tquote">“{r.text}”</p>}
      {r.helpful > 0 && <span className="mh-thelp">{r.helpful} people found this helpful</span>}
      <div className="mh-tfoot">
        <span className="mh-av" style={{ background: r.color }}>{r.name.charAt(0)}</span>
        <span>
          <b>{r.name}</b>
          <small>
            {r.from !== PLAY && <MapPin size={12} aria-hidden="true" />}
            {r.from}
          </small>
        </span>
      </div>
    </div>
  </article>
);

const HomeTestimonials = () => (
  <section className="mh-tsec" id="testimonials" aria-labelledby="mh-t-h">
    <div className="mh-tsec-head">
      <div className="mh-rule">
        <i aria-hidden="true" />
        <span>Real customer reviews</span>
        <i aria-hidden="true" />
      </div>
      <h2 id="mh-t-h">What our customers are saying</h2>
      <p>Real stories from property owners who used JaaGa for documents, checks, and peace of mind.</p>
    </div>
    <div className="mh-strip">
      <div className="mh-track mh-ttrack">
        {[...REVIEWS, ...REVIEWS].map((r, i) => (
          <ReviewCard key={i} r={r} hidden={i >= REVIEWS.length} />
        ))}
      </div>
    </div>
  </section>
);

export default HomeTestimonials;
